import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { ICommunityEngagementActions, IThunkRefreshMonthlyRecord } from '../types';

const onRefreshMonthlyRecord: IThunkRefreshMonthlyRecord = thunk(
  async ({ setMonthlyRecord }: Actions<ICommunityEngagementActions>, { signal, ...request }) => {
    const record = await api.communityEngagement
      .getMonthlyRecord(request, signal)
      .then(response => response.data);

    setMonthlyRecord(record);
  },
);

export default onRefreshMonthlyRecord;
